import {
  Button,
  Checkbox,
  IconButton,
  InputAdornment,
  TextField,
  Tabs,
  Tab,
} from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";
import { useNavigate } from "react-router-dom";
import AuthLayout from "./AuthLayout";
import { VisibilityOff, Visibility, EmailOutlined, LockOutlined, Apple } from "@mui/icons-material";
import React, { useState } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

const GoogleIcon = () => (
  <svg width="20" height="20" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z" />
    <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z" />
    <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z" />
    <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z" />
  </svg>
);

const FacebookIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="#1877F2" xmlns="http://www.w3.org/2000/svg">
    <path d="M24 12.07C24 5.41 18.63 0 12 0S0 5.4 0 12.07C0 18.1 4.39 23.1 10.13 24v-8.44H7.08v-3.49h3.04V9.41c0-3.02 1.8-4.7 4.54-4.7 1.31 0 2.68.24 2.68.24v2.97h-1.5c-1.5 0-1.96.93-1.96 1.89v2.26h3.32l-.53 3.5h-2.8V24C19.62 23.1 24 18.1 24 12.07z" />
    <path d="M15.46 15.56l.53-3.5h-3.32v-2.26c0-.96.47-1.89 1.96-1.89h1.5V5.11s-1.37-.24-2.68-.24c-2.73 0-4.54 1.68-4.54 4.7v2.72H7.08v3.49h3.04V24c.62.1 1.25.15 1.88.15s1.27-.05 1.88-.15v-8.44h3.58z" fill="white" />
  </svg>
);

const Login = () => {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [tabValue, setTabValue] = useState(0);
  const [phone, setPhone] = useState("");

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  const handleClickShowPassword = () => {
    setShowPassword((prev) => !prev);
  };

  const handleMouseDownPassword = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (tabValue === 1) {
      navigate("/otp");
    } else {
      // TODO: Add login logic here
      navigate("/dashboard");
    }
  };

  return (
    <AuthLayout>
      <div className="authBox">
        <h2>Log in to your account</h2>
        <p className="subtitle">Enter your email or phone number to continue</p>

        <div className="auth_tabs">
          <Tabs value={tabValue} onChange={handleTabChange} variant="fullWidth">
            <Tab label="Email" />
            <Tab label="Phone" />
          </Tabs>
        </div>

        <form className="form" onSubmit={handleSubmit}>
          {tabValue === 0 ? (
            <>
              <div className="control_group text_field">
                <label htmlFor="email">Email Address</label>
                <TextField
                  id="email"
                  name="email"
                  type="email"
                  placeholder="Enter email address"
                  fullWidth
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <EmailOutlined style={{ color: "rgba(255, 255, 255, 0.4)" }} />
                      </InputAdornment>
                    ),
                  }}
                />
              </div>

              <div className="control_group text_field" style={{ marginTop: 15 }}>
                <label htmlFor="password">Password</label>
                <TextField
                  id="password"
                  name="password"
                  placeholder="Enter password"
                  fullWidth
                  type={showPassword ? "text" : "password"}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <LockOutlined style={{ color: "rgba(255, 255, 255, 0.4)" }} />
                      </InputAdornment>
                    ),
                    endAdornment: (
                      <InputAdornment position="end" className="eye_btn">
                        <IconButton
                          aria-label={
                            showPassword ? "Hide password" : "Show password"
                          }
                          onClick={handleClickShowPassword}
                          onMouseDown={handleMouseDownPassword}
                          edge="end"
                        >
                          {showPassword ? <VisibilityOff style={{ color: "rgba(255, 255, 255, 0.4)" }} /> : <Visibility style={{ color: "rgba(255, 255, 255, 0.4)" }} />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </div>
            </>
          ) : (
            <div className="control_group">
              <label htmlFor="phone">Phone Number</label>
              <PhoneInput
                country={"ae"}
                value={phone}
                onChange={(phone) => setPhone(phone)}
                placeholder="Enter number"
                enableSearch={true}
              />
            </div>
          )}

          <div className="control_group d_flex rem_me">
            <div className="remember_box">
              <FormControlLabel
                control={<Checkbox />}
                name="remember"
                label="Remember me"
              />
            </div>
            <button
              type="button"
              className="anchor_link"
              onClick={() => navigate("/forgot-password")}
            >
              Forgot Password?
            </button>
          </div>

          <div className="form_btn">
            <Button
              type="submit"
              className="btn btn_primary w_100"
              variant="contained">
              Log In
            </Button>
          </div>

          <div className="divider">or continue with</div>

          <div className="social_login">
            <Button variant="outlined" startIcon={<GoogleIcon />} onClick={() => window.open("https://google.com/", "_blank")}>Google</Button>
            <Button variant="outlined" startIcon={<FacebookIcon />} onClick={() => window.open("https://www.facebook.com/login.php", "_blank")}>Facebook</Button>
            <Button variant="outlined" startIcon={<Apple />} onClick={() => window.open("https://appleid.apple.com/", "_blank")}>Apple</Button>
          </div>

          <div className="auth_bottom">
            <p>
              Don't have an account?{" "}
              <button
                type="button"
                className="link"
                onClick={() => navigate("/signup")}
              >
                Sign Up
              </button>
            </p>
          </div>
        </form>
      </div>
    </AuthLayout>
  );
};

export default Login;
